import { BasketAccount } from '@epicuro-next/data/baskets-dto';

/**
 * Get Shipping Option id.
 */
export function getSelectedShippingOptionId(
  basketAccounts: BasketAccount[],
): string {
  return basketAccounts
    ? basketAccounts.find(
        (basketAccount) => basketAccount.selectedShippingOptionId,
      )?.selectedShippingOptionId ?? ''
    : '';
}
